import { TRenderProps } from '@/lib/contentstack-sdk/types/component';

import RenderAllComponents from './RenderAllComponents';

export default function RenderComponents({
  body,
  entryUid,
  contentTypeUid,
  locale,
  showAbaForm,
  isPage = true,
}: TRenderProps) {
  return (
    <>
      {isPage ? (
        <div
          data-pageref={entryUid}
          data-contenttype={contentTypeUid}
          data-locale={locale}
          data-theme="light"
        >
          {/* SSR Components */}
          <RenderAllComponents body={body} showAbaForm={showAbaForm} />
        </div>
      ) : (
        <>
          <RenderAllComponents body={body} showAbaForm={false} />
        </>
      )}
    </>
  );
}
